<template>
  <div class="our-content-area ptb-100 position-relative z-1">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div class="col-lg-6 col-xl-7">
          <div
            class="our-content-img-2 position-relative z-2 text-center text-lg-end"
          >
            <img
              src="@/assets/images/our-content-2.jpg"
              alt="our-content"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="100"
            />
            <img
              src="@/assets/images/our-content-3.png"
              class="our-content-3 d-none d-xl-block"
              alt="our-content-3"
            />
          </div>
        </div>

        <div
          class="col-lg-6 col-xl-5"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="our-content position-relative z-1">
            <span class="top-title">مكتبة المحتوى</span>
            <h2>عالم كامل من الترفيه بانتظارك</h2>
            <p>
              مع مجموعتنا الضخمة والشاملة من القنوات التلفزيونية العالمية، لن تفوتك أحدث المباريات الرياضية والبرامج والمسلسلات المفضلة لديك. كن أول من يشاهد الحلقات الجديدة فور نزولها.
            </p>
            <p>
              <span class="text-secondary"
                >شاهد قنوات رياضية حصرية وبث مباشر فائق الثبات كل يوم. استمتع بأقوى مكتبة ترجمة واحترافية عالية في تصنيف المحتوى لتصل إلى ما تريد بسهولة.</span
              >
            </p>
            <ul class="ps-0 list-unstyled content-list">
              <li class="d-flex align-items-center mb-3">
                <i class="ti ti-circle-check ms-2 fs-5 text-success"></i>
                <span class="text-body">أكثر من 20,000 قناة عالمية وعربية بجودة 4K / FHD</span>
              </li>
              <li class="d-flex align-items-center">
                <i class="ti ti-circle-check ms-2 fs-5 text-success"></i>
                <span class="text-body">مكتبة ضخمة تضم آلاف الأفلام والمسلسلات المحدثة يومياً</span>
              </li>
            </ul>
            <a href="https://wa.me/447429916178" target="_blank" class="btn">
              <span class="border-style">اطلب تجربة المكتبة عبر الواتساب</span>
            </a>

            <img
              src="@/assets/images/shape-7.png"
              class="shape shape-7"
              alt="shape"
            />
          </div>
        </div>
      </div>
    </div>
    <img
      src="@/assets/images/shape-17.png"
      class="shape shape-18"
      alt="shape"
    />
    <img
      src="@/assets/images/shape-18.png"
      class="shape shape-19"
      alt="shape"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MoreToStream",
});
</script>